import angular from 'angular';

let DifferentialListController = function ($filter, $mdDialog, $scope, $state, Differential, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit, orderList, showCreateDialog,  handleDelete
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'name ASC',
      like_search: '',
      like_search_fields: [
        'name'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function edit(event, differential) {
    showCreateDialog(event, differential);
  }

  function handleDelete(resource, event) {
    event.stopPropagation();

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('common-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('common-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Differential
          .destroy(resource)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.deleting = false;
            _.remove($ctrl.resources.data, resource);
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  function showCreateDialog(event, selectedDifferential) {
    $ctrl.selectedDifferential = selectedDifferential;

    let contentText = '\'differential-list-create-dialog-content\'';
    let title = selectedDifferential ? '\'common-edit\'' : '\'common-new-feminine\'';

    let dialog = {
      controller: DialogController,
      targetEvent: event,
      template:
      '<md-dialog aria-label="List dialog">' +
      '  <form name="form" ng-cloak ng-submit="saveResource(differential)">' +
      '  <md-dialog-content class="layout-padding">'+
      '  <div class="md-dialog-content" >'+
      '    <h2>{{ ' + title + ' | translate }}</h2>'+
      '' +
      '    <p>{{'+ contentText + '| translate }}</p>'+
      '' +
      '<br>' +
      '    <md-input-container class="md-block" flex>'+
      '      <label>{{ \'common-name\' | translate }}</label>'+
      '' +
      '      <input ng-model="differential.name" required>'+
      '    </md-input-container>' +
      '    </div>' +
      '    </md-dialog-content>' +
      '  <md-dialog-actions>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false
    };

    // if (false) {
    //   dialog.template += '' +
    //   '    <md-button ng-click="cancel()" class="md-raised md-warn">' +
    //   '      {{ \'common-delete\' | translate }}' +
    //   '    </md-button>' +
    //   '' +
    //   '    <span style="width: 100px;"></span>';
    // }

    dialog.template += '' +
    '    <md-button ng-click="cancel()">' +
    '      {{ \'common-cancel\' | translate }}' +
    '    </md-button>' +
    '' +
    '    <md-button type="submit"' +
    '               ng-disabled="!form.$valid" class="md-accent">' +
    '      {{ \'common-save-button-text\' | translate }}' +
    '    </md-button>' +
    '  </md-dialog-actions>' +
    '  </form>' +
    '</md-dialog>';

    $mdDialog.show(dialog)
          .then((differential) => {
            if (selectedDifferential) {
              differential = angular.extend(selectedDifferential, differential);
            }

            save(differential);
          }, () => {});
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";

    $scope.differential = angular.copy($ctrl.selectedDifferential) || {};

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.saveResource = function(differential) {
      $mdDialog.hide(differential);
    };

    $scope.deleteResource = function(differential) {
      // $mdDialog.hide(differential);
    }
  }

  // Local functions

  function loadData() {
    angular.extend($ctrl.$scope.tableConfig, $state.params);

    $ctrl.promise = Differential
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
    _.forEach(arr, item => {
      if (item.description === null || item.description === undefined) {
        item.description = $filter('translate')('common-not-informed');
      }
    });
  }

  function save(differential) {
    $ctrl.promise = Differential
      .save(differential)
      .then(response => {
        loadData();
        Toast.success($filter('translate')('differential-detail-save-success'));
      })
      .catch(err => {
        loadData();
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'differential-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
      });
  }
}

DifferentialListController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Differential', 'Toast'];

export default DifferentialListController;



// WEBPACK FOOTER //
// ./client/app/components/differential/differential-list.controller.js